import * as core from '../../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'design',
    content: {
      root: {
        elements: [
          {
            content: {
              row: {
                elements: [
                  {
                    content: {
                      widget: {
                        widget: {
                          alias: 'design.specs.table',
                        },
                      },
                    },
                    span: 12,
                  },
                ],
              },
            },
            height: 300,
          },
        ],
      },
    },
    description: 'Browse specs and their approval state',
    name: 'Design',
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicPage>
